/** Twilio webhook shapes (docs/53 §6.3). See ./index.ts for the verification rule and the VERIFY note. */
import { z } from 'zod';
import { PhoneE164 } from '../common.ts';

export const TWILIO_SIGNATURE_HEADER = 'X-Twilio-Signature';

export const TwilioMessageStatus = z.enum(['queued', 'accepted', 'scheduled', 'sending', 'sent', 'delivered', 'undelivered', 'failed', 'read', 'canceled', 'receiving', 'received']);

/** Status callback, `application/x-www-form-urlencoded`. */
export const TwilioStatusCallback = z.looseObject({
  AccountSid: z.string().regex(/^AC[a-f0-9]{32}$/),
  MessageSid: z.string().regex(/^(SM|MM)[a-f0-9]{32}$/),
  MessageStatus: TwilioMessageStatus,
  To: z.string().max(64),
  From: z.string().max(64).optional(),
  ErrorCode: z.string().regex(/^\d{3,6}$/).optional(),
  MessagingServiceSid: z.string().regex(/^MG[a-f0-9]{32}$/).optional(),
});

/** Inbound message webhook. `OptOutType` appears when Advanced Opt-Out is on (VERIFY). */
export const TwilioInbound = z.looseObject({
  AccountSid: z.string().regex(/^AC[a-f0-9]{32}$/),
  MessageSid: z.string().regex(/^(SM|MM)[a-f0-9]{32}$/),
  From: PhoneE164,
  To: PhoneE164,
  Body: z.string().max(1600),
  NumMedia: z.string().regex(/^\d{1,2}$/),
  OptOutType: z.enum(['STOP', 'START', 'HELP']).optional(),
  MessagingServiceSid: z.string().regex(/^MG[a-f0-9]{32}$/).optional(),
});
